<template>
  <section class="help_box">
    <div class="name">{{axData.title}}</div>
    <div class="table">
      <table>
        <thead>
          <tr>
            <th v-for="(item, index) in axData.tableDate.column" :key="index">
              {{item}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in axData.tableDate.data" :key="index">
            <td v-for="(items, idx) in item" :key="idx">{{items}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="remind">
      <p>温馨提示：</p>
      <p v-for="(item, index) in axData.promptData" :key="index" v-html="item"></p>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'helpPage',
    props:{
      axData: {
        type: Object,
        default: {}
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.help_box {
  padding: 0 16px;
  .name {
    height: 34px;
    line-height: 34px;
    font-size: 14px;
    color: $des-color;
  }
  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    font-size: 15px;
    overflow: hidden;
    background-color: #fff;
    border-radius: 4px;
    thead {
      color: #000;
      height: 44px;
      font-size: 17px;
      th {
        font-weight: 600;
        position: relative;
        &::after{
          position: absolute;
          content: " ";
          pointer-events: none;
          right: 0;
          bottom: 0;
          left: 0;
          border-bottom: 1px solid $border-color;
          z-index: 10;
          transform: scaleY(0.5);
        }
      }
    }
    tr {
      height: 44px;
      color: $value-color;
    }
  }
  .remind {
    margin-top: 20px;
    color: $des-color;
    font-size: 14px;
    line-height: 20px;
    p {
      /deep/ a {
        color: $file-color;
        font-size: 14px;
      }
    }
  }
}
</style>
